import React,{Fragment, Component} from 'react';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
import bgimg from './../../../images/bg-view.png';
import img1 from './../../../images/img1.jpg';
import img2 from './../../../images/adv1.jpg';

/// modal
import { Modal } from "react-bootstrap";
import { sendContactEmail } from '../../../api/emailsender/EmailSender';
import { serializeForm } from '../../../api/emailsender/formSerialize';

const Footer2 = FooterPremium;

class SubscriptionBox2 extends Component{
	
	/// model box
	state = {
		// initial state
		show: true,
		appointmentSubmitting: false,
		appointmentError: '',
	}

	handleAppointmentSubmit = async (e) => {
		e.preventDefault();
		const form = e.currentTarget;
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}
		this.setState({ appointmentSubmitting: true, appointmentError: '' });
		const formData = serializeForm(form);
		formData.formSource = 'Subscription modal box 2';
		const result = await sendContactEmail(formData, 'Star Giga — Virtual project tour registration');
		this.setState({ appointmentSubmitting: false });
		if (result.ok) {
			form.reset();
			this.handleClose();
			alert('Thank you! Our sales team will contact you shortly.');
		} else {
			this.setState({ appointmentError: result.error });
			alert(result.error);
		}
	};

	handleClose = () => {
		this.setState({ show: false });
	};
	handleShow = () => {
		this.setState({ show: true });
	};
	render(){
		return(
			<Fragment>
				<Header />	
				<div className="page-content bg-white">
					{/*  banner  */}
					<PageTitle motherMenu="Subscription Modal Box 2" activeMenu="Subscription Modal Box 2" />
					<div className="content-inner" data-content="PORTFOLIO">				
						<div className="container">
							
							<button className="btn btn-primary" onClick={this.handleShow} type="button" data-toggle="modal" data-target="#exampleModal">Open Modal Box</button>
							{/*  InquiryModal  */}
								
							<Modal show={this.state.show} onHide={this.handleClose} className=" modal fade inquiry-modal-2" id="exampleModal" tabindex="-1" >
								<div  role="document">
									<button type="button" className="close" onClick={this.handleClose} data-dismiss="modal"  aria-label="Close" >
									  <span aria-hidden="true">&times;</span>
									</button>
									<div className="inquiry-adv">
										<img src={img1} alt=""/>
										<img src={img2} alt=""/>
									</div>
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title" id="exampleModalLongTitle">Register now for a virtual project tour with our sales expert.</h5>
										</div>
										<div className="modal-body">
											<div className="dzFormMsg">
												{this.state.appointmentError && (
													<div className="alert alert-danger">{this.state.appointmentError}</div>
												)}
											</div>
											<form className="dzForm row sp15" onSubmit={this.handleAppointmentSubmit}>
												<div className="form-group col-md-3">
													<input type="text" name="name" required className="form-control" placeholder="Enter Name" />
												</div>
												<div className="form-group col-md-3">
													<input type="text" name="phone" required className="form-control" placeholder="Enter Phone No." />
												</div>
												<div className="form-group col-md-3">
													<input type="email" name="email" required className="form-control" placeholder="Enter Email Address" />
												</div>
												<div className="form-group col-md-3">
													<select className="form-control" name="country" required>
														<option>Select Location</option>
														<option>UK</option>
														<option>India</option>
														<option>Brazil</option>
														<option>Australia</option>
													</select>
												</div>
												<div className="col-md-12 text-center">
													<button name="submit" type="submit" value="Submit" className="btn btn-primary btn-block" disabled={this.state.appointmentSubmitting}>
														{this.state.appointmentSubmitting ? 'Sending…' : 'SUBMIT'}
													</button>
												</div>	
											</form>
										</div>
									</div>
								</div>		
							</Modal>
						</div>
					</div>
					<div>				
						<img src={bgimg} className="bg-view" alt=""/>
					</div>
				</div>
				<Footer2 />	
			</Fragment>
		)
	}
}
export default SubscriptionBox2;
